if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    // Check if skin quiz completion cookie is valid
    isQuizCookieValid() {
      return document.cookie.split(';').some(c => c.trim().startsWith('skin_quiz_completed='));
    }

    // Add skin_quiz_converted attribute if cookie is valid
    async updateQuizAttribute() {
      if (!this.isQuizCookieValid()) return;

      try {
        // Get existing cart attributes
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const existingAttributes = cart.attributes || {};

        // Only update if not already set
        if (existingAttributes.skin_quiz_converted === '1') return;

        // Add quiz attribute while preserving existing ones
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { ...existingAttributes, skin_quiz_converted: '1' }
          })
        });
      } catch (error) {
        console.error('Error updating quiz attribute:', error);
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      if (this.submitButton && this.submitButton.querySelector('.loading-overlay__spinner')) {
        this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const addCartRequest = {
        route: `${routes.cart_add_url}`,
        config: config,
        formData: formData
      }
      const discountUrl = this.submitButton.getAttribute("data-discount-url");
      
      if (discountUrl) {
        fetch(discountUrl)
          .then((response) => this.sendAddCartRequest(addCartRequest))
          .catch((e) => {
            console.error(e);
          });
      }
      else {
        this.sendAddCartRequest(addCartRequest);
      }
    }

    sendAddCartRequest(addCartRequest) {
      fetch(addCartRequest.route, addCartRequest.config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: addCartRequest.formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: addCartRequest.formData.get('id')});
          this.error = false;
          // Update quiz attribute if cookie is valid
          this.updateQuizAttribute();
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if(this.submitButton && this.submitButton.querySelector('.loading-overlay__spinner')) {
            this.submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
